// Utilities for rendering messages on Trends tab
const wayDown = [
  'pace is currently below your goal pace.',
  'is trailing behind your goal.',
  'pace is behind your goal this month.',
  'is below your goal so far this month.'
]

const down = [
  'pace is within range of your goal.',
  'is lower than your goal but within range.',
  'pace is a little lower than your goal.',
  'is a little off the pace so far this month.',
  'is a bit below your goal pace.'
]

const slightlyDown = [
  'pace is really close to your goal.',
  'pace is on track for the month.',
  'is almost at your goal.',
  'is right at your goal pace.',
  'is looking good!'
]

const slightlyUp = [
  'is on pace for the month.',
  'is right on track.',
  'is just ahead of your goal.',
  'is above your monthly goal.',
  'is above the pace for the month.'
]

const up = ['is ahead of the pace.']

const wayUp = ['is crushing it.']

export const renderMessage = (percentageGoal) => {
  if (percentageGoal < -33) {
      return wayDown[Math.floor(Math.random() * wayDown.length)]
  } else if (percentageGoal >= -33 && percentageGoal < -10) {
      return down[Math.floor(Math.random() * down.length)]
  } else if (percentageGoal >= -10 && percentageGoal < 0) {
      return slightlyDown[Math.floor(Math.random() * slightlyDown.length)]
  } else if (percentageGoal < 10 && percentageGoal >= 0) {
      return slightlyUp[Math.floor(Math.random() * slightlyUp.length)]
  } else if (percentageGoal >= 10 && percentageGoal < 33) {
      return up[Math.floor(Math.random() * up.length)]
  } else if (percentageGoal >= 33) {
      return wayUp[Math.floor(Math.random() * wayUp.length)]
  } else {
      return 'is recalculating'
  }
}

export const renderShortMessage = (percentageGoal, comparison) => {
  const checkBlankComparison = comparison === '' ? 'your goal' : comparison
  if (percentageGoal < -33) {
      return `is down, compared to ${checkBlankComparison}`
  } else if (percentageGoal >= -33 && percentageGoal < -10) {
      return `down, but within range of ${checkBlankComparison}`
  } else if (percentageGoal >= -10 && percentageGoal < 0) {
      return `just below ${checkBlankComparison}`
  } else if (percentageGoal < 10 && percentageGoal >= 0) {
      return `is above ${checkBlankComparison}`
  } else if (percentageGoal >= 10 && percentageGoal < 33) {
      return `way above ${checkBlankComparison}`
  } else if (percentageGoal >= 33) {
      return `is awesome, compared to ${checkBlankComparison}`
  } else {
      return 'is recalculating'
  }
}